import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{attrs:{"block":"","large":"","tile":"","dark":"","color":_vm.accentColor},on:{"click":function($event){return _vm.backToLandingPage()}}},[_c(VIcon,{attrs:{"left":""}},[_vm._v(" mdi-keyboard-backspace ")]),_c('span',[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }